import React from 'react';

const Topbar = ({ title, subtitle }) => (
  <header className="admin-topbar" id="admin-topbar">
    <div>
      <div className="admin-topbar-title" id="admin-topbar-title">{title}</div>
      {subtitle && <div className="admin-topbar-subtitle" id="admin-topbar-subtitle">{subtitle}</div>}
    </div>
    <div className="admin-topbar-right">
      <span className="admin-topbar-badge" id="admin-topbar-badge">🦷 UK Dental Studio</span>
    </div>
  </header>
);

export default Topbar;
